module.exports = __webpack_public_path__ + "static/img/logo-WEST-COAST.28833b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-WEST-COAST.svg
// module id = 6cKl
// module chunks = 1